import { FC } from 'react';
import styled from 'styled-components';
import { GenericContainerCard } from '../UtilitiesMatchMobile/GenericCssComponentMatchMobile';
import { SideSpace } from '../UtilitiesMatchMobile/GenericCssComponentMatchMobile';
import CenterInfoFightRendering from '../UtilitiesMatchMobile/GenericRendering/CenterInfoFightRendering';
import RenderWrestlerWhenThreeInSpace from './RenderWrestlerBySpaceAndNumber/RenderWrestlerWhenThreeInSpace';
import RenderingMatchWithConditionExtended from '../UtilitiesMatchMobile/RenderingMatchWithConditionExtended';
import { Match } from '../../../../types';

export const WrapperSideSpace = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
`;

interface NwoSixMatchRenderProps {
    matchInfo: Match;
    withWinner?: boolean;
    isExpanded?: boolean;
}

const NwoSixMatchRender: FC<NwoSixMatchRenderProps> = ({ matchInfo, withWinner = false, isExpanded = false }) => {
    // divido matchInfo.wrestlers in due array uguale.. se dispari, il primo array avra' un elemento in più
    const wrestlers1 = matchInfo.wrestlers.slice(0, Math.ceil(matchInfo.wrestlers.length / 2));
    const wrestlers2 = matchInfo.wrestlers.slice(Math.ceil(matchInfo.wrestlers.length / 2));

    function renderGenericContainerCard() {
        return (
            <GenericContainerCard className='nwo-six-match-render'
            height={isExpanded ? '80%' : '100%'}
            >
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        {wrestlers1.map((wrestler, index) => (
                            <RenderWrestlerWhenThreeInSpace
                                wrestler={wrestler}
                                side='left'
                                key={index}
                                withWinner={withWinner}
                            />
                        ))}
                    </WrapperSideSpace>

                </SideSpace>
                <CenterInfoFightRendering matchInfo={matchInfo} typeMatch='Nwo-Six' />
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        {wrestlers2.map((wrestler, index) => (
                            <RenderWrestlerWhenThreeInSpace
                                wrestler={wrestler}
                                side='right'
                                key={index}
                                withWinner={withWinner}
                            />
                        ))}
                    </WrapperSideSpace>

                </SideSpace>
            </GenericContainerCard>
        )
    }

    return (
        RenderingMatchWithConditionExtended({ renderGenericContainerCard, isExpanded, matchInfo })
    )
}

export default NwoSixMatchRender;
